import request from '@/utils/request'

//新增用户
export function AddUser(data) {
    return request({
        url: '/User/AddUser',
        method: 'post',
        data: data
    })
}

//修改用户
export function UpdateUser(data) {
    return request({
        url: 'User/UpdateUser',
        method: 'post',
        data: data
    })
}

//查询用户
export function GetUserPageList(data) {
    return request({
        url: '/User/GetUserPageList',
        method: 'post',
        data: data
    })
}

//新增客户
export function AddMailout(data) {
    return request({
        url: '/User/AddMailout',
        method: 'post',
        data: data
    })
}

//修改客户
export function UpdateMailout(data) {
    return request({
        url: '/User/UpdateMailout',
        method: 'post',
        data: data
    })
}

//管理员才有权限获取客户列表
export function GetMailoutPageList(data) {
    return request({
        url: '/User/GetMailoutPageList',
        method: 'post',
        data: data
    })
}

//获取当前的数据库里面的所有用户Code
export function GetUserCodeList(data) {
    return request({
        url: '/User/GetUserCodeList',
        method: 'post',
        data: data
    })
}
